// assets
import { ProfileOutlined, UnorderedListOutlined } from '@ant-design/icons';

// icons
const icons = {
  ProfileOutlined,
  UnorderedListOutlined
};

// ==============================|| MENU ITEMS - PROJECT TRACKER ||============================== //

const utilities = {
  id: 'project-tracker',
  title: 'Project Tracker',
  type: 'group',
  children: [
    {
      id: 'project-tracker-overview',
      title: 'Overview',
      type: 'item',
      url: '/project-tracker',
      icon: icons.UnorderedListOutlined
    }
  ]
};

export default utilities;
